module.exports = require("@wildboar/x500/src/lib/modules/OperationalBindingManagement/OpBindingErrorParam-problem.ta");